export const dropDown = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "20px",
};

export const selectContainer = ({ minWidth }) => ({
  minWidth,
  flexGrow: "1",
  flexShrink: "1",
});
